export const projectData = [
  {
    title: 'StartBooking | Next js',
    text: 'С помощью этого сайта вы можете ознакомиться с отелями, которые присутствуют в Узбекистане и забронировать их.',
    img: 'projectImg/startbooking.png',
    technologies: ['Tailwind CSS', 'Next js', 'Typescript', 'i18next'],
    url: 'https://startbooking.uz',
    urlGithub: 'https://github.com/Ibragimovrustam21/startbooking',
  },
  {
    title: 'Crown-clothing | React-Redux',
    text: 'Через приложение вы можете купить качественные товары не выходя из дома.',
    img: 'projectImg/crown.png',
    technologies: ['Styled-Components', 'React js', 'Redux', 'Redux-thunk'],
    url: 'https://crown-wb.netlify.app',
    urlGithub: 'https://github.com/Ibragimovrustam21/crown-wb',
  },
  {
    title: 'Olmo.uz | React',
    text: 'Приложение сделано для усвоение навыков.',
    img: 'projectImg/olmo.png',
    technologies: ['HTML5', 'CSS3/SASS', 'Material-UI', 'React js'],
    url: 'https://olmo.netlify.app/',
    urlGithub: 'https://github.com/Ibragimovrustam21/olmo',
  },
  {
    title: 'Tour App SPA | Typescript',
    text: 'Приложение сделано для усвоение навыков.',
    img: 'projectImg/tour.png',
    technologies: ['HTML5', 'CSS3/SASS', 'Antd-design', 'React js', 'Typescript'],
    url: 'https://tour-ws.netlify.app/',
    urlGithub: 'https://github.com/Ibragimovrustam21/tourApp',
  },
  {
    title: 'Get Weather | React',
    text: 'Приложение предоставляет национальный и местный прогноз погоды для городов.',
    img: 'projectImg/weather.png',
    technologies: ['HTML5', 'CSS3/SASS', 'Bootstrap', 'Axios', 'React js'],
    url: 'https://obhavoweather.netlify.app/',
    urlGithub: 'https://github.com/Ibragimovrustam21/Weather_App_React/tree/weather',
  },
  {
    title: 'Todo App | Typescript',
    text: 'С помощью этой приложений вы можете создать свой todo-list.',
    img: 'projectImg/todo.png',
    technologies: ['HTML5', 'CSS3/SASS', 'Materialize', 'React js', 'Typescript'],
    url: 'https://todoappts.netlify.app/',
    urlGithub: 'https://github.com/Ibragimovrustam21/todo_app_typescript/tree/todo',
  },
  {
    title: 'QRCode | React',
    text: 'С помощью этой приложений вы можете генерировать свой QRCode.',
    img: 'projectImg/qr.png',
    technologies: ['HTML5', 'CSS3/SASS', 'Bootstrap', 'Axios', 'React js'],
    url: 'https://qrcode-21.netlify.app/',
    urlGithub: 'https://github.com/Ibragimovrustam21/QRCode/tree/qrcode',
  },
  {
    title: 'You Tube Clone version | React',
    text: 'Приложение клон сайта youtube.com.',
    img: 'projectImg/youtube.png',
    technologies: ['HTML5', 'CSS3/SASS', 'Bootstrap', 'Axios', 'React js'],
    url: 'https://youtubeclone-21.netlify.app/',
    urlGithub: 'https://github.com/Ibragimovrustam21/you_tube_clone/tree/youtube',
  },
  {
    title: 'Cryptocurrency FP | React',
    text: 'Приложение представит вам Cryptocurrency Finance Price.',
    img: 'projectImg/crypto.png',
    technologies: ['HTML5', 'CSS3/SASS', 'Bootstrap', 'Axios', 'React js'],
    url: 'https://cryptocurrency-21.netlify.app/',
    urlGithub: 'https://github.com/Ibragimovrustam21/Cryptocurrency-Finance-Price/tree/crypto',
  },
  {
    title: 'Albison SPA | React',
    text: 'Приложение сделано для усвоение навыков.',
    img: 'projectImg/albison.png',
    technologies: ['HTML5', 'CSS3/SASS', 'Antd-design', 'React js'],
    url: 'https://albison-ws.netlify.app/',
    urlGithub: 'https://github.com/Ibragimovrustam21/albison/tree/albison',
  }
]